import React from "react";
import { Outlet } from "react-router-dom";
import TopNavBar from "components/TopNavBar";
import { Box } from "@mui/material";

const ProjectHeader = () => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", flexDirection: "column", backgroundColor: "background.default" }}>
      <TopNavBar />

      
      <Box sx={{  flexGrow: 1 }}>
        <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectHeader;
